<template>
  <div :class="['product', 'product_' + viewtype]">
    <router-link
      :to="`/catalog/${$route.params.group_slug}/${product.slug.split('_').join('-')}`"
      class="product__main"
    >
      <div class="product__outer-image-container">
        <div class="product__medium-image-container">
          <div class="product__internal-image-container">
            <img
              :src="`${img_url}${product.image}`"
              :alt="product.name"
              class="product__image"
            />
          </div>
        </div>
      </div>

      <div class="product__info-container">
        <h4 class="product__name">
          <span class="product__name-text">{{ product.name }}</span>
        </h4>
        <div
          v-if="show_description"
          class="product__description"
          v-html="product.description"
        ></div>
        <div class="product__description">
          <span
            v-for="property in product.properties.slice(0, 7)"
            :key="property.property_id"
          >
            {{ property.property_name }} : {{ property.property_value }}
            <br />
          </span>
        </div>

        <div class="product__meta">
          <div class="product__meta-cell">
            <strong class="product__meta-name">Код:</strong>
            <span class="product__meta-value">{{ product.code_1c }}</span>
          </div>
          <div v-if="product.article.length" class="product__meta-cell">
            <strong class="product__meta-name">Арт.:</strong>
            <span class="product__meta-value">{{ product.article }}</span>
          </div>
        </div>
      </div>
    </router-link>
    <!--    <a href="#" class="product__main">-->
    <!--      -->
    <!--    </a>-->

    <!--    дополнительный контейнер-->
    <div class="product__aside">
      <!-- цена-->
      <div class="product__price-container">
        <!--  <div class="product__price">{{ product.price_value }} <span class="currency">&#8381;</span></div>-->
        <div class="product__price">{{ product.price_name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Product",
  props: {
    product: {},
  },
  data() {
    return {
      img_url: process.env.VUE_APP_IMG_URL,
      show_description: false,
    };
  },
  computed: {
    viewtype() {
      return this.$store.getters["group_info/GET_VIEWTYPE"];
    },
  },
};
</script>

<style scoped></style>
